import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import CasesPage from '@/pages/cases';
import CasePage from '@/pages/cases/[id]';
import NewCasePage from '@/pages/cases/new';
import KnowledgeBasePage from '@/pages/knowledge-base';
import LoginPage from '@/pages/login';
import NotFound from '@/pages/NotFound';

// Root handler that preserves auth callback params instead of discarding them via immediate redirect
const RootHandler: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const auth = params.get('auth');
  const token = params.get('token');

  // If OAuth callback params present, send user to login page (public) which will process them
  if (auth === 'success' && token) {
    return <Navigate to={`/login?${params.toString()}`} replace />;
  }

  // Otherwise normal index redirect
  return <Navigate to="/cases" replace />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected */}
      <Route
        path="/cases"
        element={
          <ProtectedRoute>
            <CasesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/new"
        element={
          <ProtectedRoute>
            <NewCasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/docs"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/letters"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/exhibit-lists"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/drafting"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/forms"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/petition"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:id/uscis-requests"
        element={
          <ProtectedRoute>
            <CasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/knowledge-base"
        element={
          <ProtectedRoute>
            <KnowledgeBasePage />
          </ProtectedRoute>
        }
      />

      {/* Root */}
      <Route path="/" element={<RootHandler />} />
      {/* Fallback 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
